import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import employeeService from '../../../services/Employee.service'
import StencilLinkStyling from '../../../components/v2/common/StencilLinkStyling';

import { Card, CardStatus } from '@amzn/stencil-react-components/card'
import { Col, Flex } from '@amzn/stencil-react-components/layout'
import { Expander } from '@amzn/stencil-react-components/expander'
import { H3, Text } from '@amzn/stencil-react-components/text'

class Notifications extends Component {

    constructor(props) {
      super(props);
    }

    createNotificationCard = (notification, isAction) => {
      return (
        <Card
          dataTestId="Notification-Card"
          status={isAction ? CardStatus.Warning: CardStatus.Informational}>
          <Col width="100%" gridGap="S200">
            <H3>{notification.title}</H3>
            <Col width="100%" gridGap="S300">
              <StencilLinkStyling>
                <Text dangerouslySetInnerHTML={{ __html: notification.message}}/>
              </StencilLinkStyling>
            </Col>
          </Col>
        </Card>
      )
    }

    render() {
      const { t, actionNotifications, genericNotifications } = this.props;
      const count = actionNotifications.length + genericNotifications.length;
      const titleText = t('Notification.NotificationsLabel') + " (" + count + ")";

      return (
        <Expander
          dataTestId="Notifications-Expander"
          titleText={titleText}
          headingLevel={2}
        >
          <Flex flexDirection="column" gridGap="S200">
          {actionNotifications.map((notification) => (
            this.createNotificationCard(notification, true)
          ))}
          {genericNotifications.map((notification) => (
            this.createNotificationCard(notification, false)
          ))}
          </Flex>
      </Expander>
    );
  }
}

const mapState = state => ({
  actionNotifications: employeeService.getNonGenericNotifications(state.employee),
  genericNotifications: employeeService.getGenericNotifications(state.employee)
});

export default connect(mapState)(withTranslation('translationsV2') (Notifications));
